require('./promo-codes-form.scss')

module.exports = {
  template: require('./promo-codes-form.pug')()
  controller: require('./promo-codes-form.ctrl')
  bindings:
    promoCode: '<'
    onSubmit: '&'
}
